// node-modules
// import Hammer from 'hammerjs';

// constants
import { DOCUMENT_ELEMENT, SELECTORS, KEY_CODES } from '@/scripts/constants';

// other
import { toggleModal, transitionend } from '@/scripts/utils';

// assets
import './VideoModal.scss';

const defaults = {
  triggerElements: '[data-role*="video-modal-trigger"]',
  modalElement: '[data-role*="video-modal-element"]',
  modalContent: '[data-role*="video-modal-content"]',
  modalClose: '[data-role*="video-modal-close"]',
  activeClass: SELECTORS.video_modal_opened,
  loadingClass: SELECTORS.loading,
};
export default class VideoModal {
  constructor(props) {
    const options = Object.assign({}, defaults, props);

    this.triggerElements = options.triggerElements;
    if (!document.querySelectorAll(this.triggerElements).length) return;
    this.modal = document.querySelector(options.modalElement);
    this.modalContent = this.modal.querySelector(options.modalContent);
    this.closeElement = this.modal.querySelector(options.modalClose);
    this.activeClass = options.activeClass;
    this.loadingClass = options.loadingClass;

    this.init();
  }

  get activeStatus() {
    return DOCUMENT_ELEMENT.classList.contains(this.activeClass);
  }

  toggleStatus(allow) {
    DOCUMENT_ELEMENT.classList.toggle(this.activeClass, allow);
    return toggleModal(
      allow,
      null,
      this.modal,
    );
  }

  initModal(el) {
    const { params } = el.dataset;
    const {
      type, url, data, copyContentToModal,
    } = JSON.parse(params);
    this.toggleStatus(true);
    if (copyContentToModal) {
      $(this.modalContent).append($(el).find('[data-role*="content-to-fill-modal"]').html());
    } else {
      this.modal.classList.add(this.loadingClass);
      $.ajax({
        type,
        url,
        data,
        success: (result) => {
          $(this.modalContent).append(result);
          const $video = $(this.modalContent).find('video');
          $video.on('canplay', () => {
            $video[0].play();
            this.modal.classList.remove(this.loadingClass);
          });
        },
      });
    }
    $(this.modalContent).find('[data-close-modal]').click(this.destroyModal.bind(this));
  }

  destroyModal() {
    this.toggleStatus(false);
    transitionend(this.modal, 'transitionend', () => {
      $(this.modalContent).children().remove();
    });
  }

  initKeyboardNav() {
    document.addEventListener('keyup', (e) => {
      if (e.keyCode === KEY_CODES.esc && this.activeStatus) {
        this.destroyModal();
      }
    });
  }

  // initMobileNav() {
  //   const hammer = new Hammer(this.modal);
  //   hammer.get('swipe').set({ direction: Hammer.DIRECTION_VERTICAL });
  //   hammer.on('swipeup', () => {
  //     if (this.activeStatus) this.destroyModal();
  //   });
  // }

  init() {
    const self = this;
    this.initKeyboardNav();
    // if (isMobile()) {
    //   this.initMobileNav();
    // }
    $(document).on('click', this.triggerElements, function click(e) {
      e.preventDefault();
      self.initModal(this);
    });
    this.closeElement.addEventListener('click', () => {
      this.destroyModal();
    });
  }
}



// WEBPACK FOOTER //
// ./components/VideoModal/VideoModal.js